import { apiRequest } from "./axiosInstance";

// Get all expenses with filters, sorting, and pagination
export const getExpenseApi = async (params) => {
  const response = await apiRequest({
    url: "/expenses",
    method: "GET",
    params: params
  });
  return response?.data;
};

// Get single expense by ID
export const getExpenseByIdApi = async (id) => {
  const response = await apiRequest({
    url: `/expenses/${id}`,
    method: "GET"
  });
  return response?.data;
};

// Create new expense
export const createExpenseApi = async (body) => {
  try {
    const data = await apiRequest({
      url: "/expenses",
      method: "POST",
      data: body,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return { success: true, message: data?.data };
  } catch (error) {
    console.log(error, "error");
    return { message: error?.response?.data?.message, success: false };
  }
};

// Update expense
export const updateExpenseApi = async (id, body) => {
  try {
    const data = await apiRequest({
      url: `/expenses/${id}`,
      method: "PUT",
      data: body,
    });
    return { success: true, message: data?.data };
  } catch (error) {
    console.log(error, "error");
    return { message: error?.response?.data?.message, success: false };
  }
};

// Delete expense
export const deleteExpenseApi = async (id) => {
  try {
    const data = await apiRequest({
      url: `/expenses/${id}`,
      method: "DELETE",
    });
    return { success: true, message: data?.data };
  } catch (error) {
    console.log(error, "error");
    return { message: error?.response?.data?.message, success: false };
  }
};

// Get expense statistics
// export const getExpenseStatsApi = async (params) => {
//   try {
//     const response = await apiRequest({
//       url: "/expenses/stats",
//       method: "GET",
//       params: params
//     });
//     return { success: true, data: response?.data };
//   } catch (error) {
//     console.log(error, "error");
//     return { message: error?.response?.data?.message, success: false };
//   }
// };

export const getExpenseStatsApi = async (params) => {
  try {
    const response = await apiRequest({
      url: "/expenses/stats",
      method: "GET",
      params: params
    });
    return response?.data; // Changed from { success: true, data: response?.data }
  } catch (error) {
    console.log(error, "error");
    return { message: error?.response?.data?.message, success: false };
  }
};